interface VideoModalProps {
  onClose: () => void;
  videoUrl?: string;
}

export default function VideoModal({ onClose, videoUrl = "https://www.youtube.com/embed/Va_f0FoVO44?autoplay=1" }: VideoModalProps) {
  // Añadir parámetros para activar subtítulos y ocultar branding de YouTube
  const enhancedVideoUrl = videoUrl.includes('?') 
    ? `${videoUrl}&cc_load_policy=1&modestbranding=1&rel=0`
    : `${videoUrl}?cc_load_policy=1&modestbranding=1&rel=0&autoplay=1`;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/80 backdrop-blur-sm p-4" onClick={onClose}>
      <div className="relative w-full max-w-4xl bg-[#0A1628] rounded-xl sm:rounded-2xl overflow-hidden shadow-2xl" onClick={(e) => e.stopPropagation()}>
        <button
          onClick={onClose}
          className="absolute top-2 right-2 sm:top-4 sm:right-4 z-10 w-8 h-8 sm:w-10 sm:h-10 bg-white/10 hover:bg-white/20 rounded-full flex items-center justify-center transition-colors cursor-pointer"
        >
          <i className="ri-close-line text-white text-xl sm:text-2xl"></i>
        </button>
        
        <div className="aspect-video bg-black">
          <iframe
            width="100%"
            height="100%"
            src={enhancedVideoUrl}
            title="PreBedAI Demo Video"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            className="w-full h-full"
          ></iframe>
        </div>
      </div>
    </div>
  );
}
